import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './Header.js';
import Footer from './Footer.js';
import Home from './pages/Home.js';
import About from './pages/About.js';
import Support from './pages/Support.js';
import TermsOfService from './pages/TermsOfService.js';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import Faq from './pages/Faq.js';
import Gear from './pages/Gear.js';
import Contact from './pages/Contact.js';
import AdminReview from './pages/AdminReview.js';
import BadRequest from './pages/errors/BadRequest.js';
import Unauthorized from './pages/errors/Unauthorized.js';
import Forbidden from './pages/errors/Forbidden.js';
import NotFound from './pages/errors/NotFound.js';
import ServerError from './pages/errors/ServerError.js';
import { SidebarProvider } from '../contexts/SidebarContext.js';

const App = () => {
  return (
    <Routes>
      {/* Admin panel — renders without the site header/footer */}
      <Route path="/admin" element={<AdminReview />} />
      <Route path="/admin/index.html" element={<AdminReview />} />

      {/* Main site */}
      <Route path="*" element={<SiteLayout />} />
    </Routes>
  );
};

function SiteLayout() {
  return (
    <SidebarProvider>
      <Header />
      <main className="container py-4" style={{ display: 'flex', flexDirection: 'column' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/support" element={<Support />} />
          <Route path="/tos" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/legal" element={<Navigate to="/tos" replace />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/gear" element={<Gear />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/400" element={<BadRequest />} />
          <Route path="/401" element={<Unauthorized />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/500" element={<ServerError />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </SidebarProvider>
  );
}

export default App;
